var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "20",
        viewBox: "0 0 25 20",
      },
    },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", { attrs: { d: "M0-2h24.569v24.569H0z" } }),
        _vm._v(" "),
        _c("g", { attrs: { transform: "translate(0 .586)" } }, [
          _c("g", { attrs: { transform: "translate(0 2.42)" } }, [
            _c("path", {
              attrs: {
                fill: _vm.color,
                d: "M23.156 14.797h-7.57l-.325-2.61a2.797 2.797 0 0 0-2.772-2.45 2.797 2.797 0 0 0-2.772\n            2.45l-.324 2.61H1.79V1.846h21.366v12.951zM24.05.056H.895C.401.056 0 .456 0 .95v14.741c0\n            .494.4.895.895.895h9.162a.783.783 0 0 0 .777-.687l.438-3.52c.076-.613.6-1.076 1.217-1.076.618\n            0 1.141.463 1.217 1.076l.438 3.52c.04.326.277.583.582.662v.025H24.05c.494 0\n            .895-.4.895-.895V.951c0-.495-.401-.895-.895-.895z",
              },
            }),
          ]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: _vm.color,
              d: "M6.326 7.907a2.09 2.09 0 0 0-2.089 2.088 2.09 2.09 0 0 0 2.089 2.088 2.09 2.09 0 0 0\n          2.088-2.088 2.09 2.09 0 0 0-2.088-2.088m0 5.966a3.883 3.883 0 0 1-3.879-3.878 3.883 3.883 0 0 1\n          3.879-3.878 3.883 3.883 0 0 1 3.878 3.878 3.883 3.883 0 0 1-3.878 3.878M18.808 7.907a2.09 2.09\n          0 0 0-2.089 2.088 2.09 2.09 0 0 0 2.089 2.088 2.09 2.09 0 0 0 2.088-2.088 2.09 2.09 0 0\n          0-2.088-2.088m0 5.966a3.883 3.883 0 0 1-3.879-3.878 3.883 3.883 0 0 1 3.879-3.878 3.883\n          3.883 0 0 1 3.878 3.878 3.883 3.883 0 0 1-3.878 3.878",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: _vm.color,
              d: "M3.675 2.476H21.27V1.79H3.675v.686zm17.894 1.79H3.376c-.822\n        0-1.491-.67-1.491-1.492V1.492C1.885.669 2.554 0 3.376 0H21.57c.823 0 1.492.67\n        1.492 1.492v1.282c0 .823-.67 1.492-1.492 1.492z",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }